module.exports = __webpack_public_path__ + "images/infoe6195073a73d020d76b285be63068203.svg";